import { isProductionDomain } from "./domain";
import { detectTemplate, RendaTemplate } from "./style-loader";

const template = detectTemplate();

function getApiUrl(): string {
  const host = window.location.hostname.toLowerCase();
  const domains = [env.VITE_RENDA_DEFAULT_DOMAIN, env.VITE_RENDA_25NA7_DOMAIN];

  if (isProductionDomain(host, domains)) {
    return env.VITE_RENDA_API_URL_PROD;
  }

  return env.VITE_RENDA_API_URL_TEST;
}

function getRequiredEnv(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];

  if (typeof value !== "string" || value.length === 0) {
    throw new Error(`Missing required env variable: ${name}`);
  }

  return value;
}

const env = {
  VITE_RENDA_API_URL_TEST: getRequiredEnv("VITE_RENDA_API_URL_TEST"),
  VITE_RENDA_API_URL_PROD: getRequiredEnv("VITE_RENDA_API_URL_PROD"),
  VITE_RENDA_DEFAULT_DOMAIN: getRequiredEnv("VITE_RENDA_DEFAULT_DOMAIN"),
  VITE_RENDA_25NA7_DOMAIN: getRequiredEnv("VITE_RENDA_25NA7_DOMAIN"),
};

interface Config {
  apiUrl: string;
  template: RendaTemplate;
  logoPath: string;
  loginLogoPath: string | null;
  headerLogoPath: string | null;
  headerLogoURL: string | null;
  backGroundImage: string | null;
  rentAreaURL: string | null;
  rentAreaLabel: string | null;
}

const templateConfigByTemplate: Record<
  RendaTemplate,
  Omit<Config, "apiUrl" | "template">
> = {
  renda: {
    logoPath: "/logo-grey.svg",
    loginLogoPath: null,
    headerLogoPath: null,
    headerLogoURL: null,
    backGroundImage: null,
    rentAreaURL: null,
    rentAreaLabel: null,
  },
  twentyFiveSeven: {
    logoPath: "/logo-grey.svg",
    loginLogoPath: "/257-logo.svg",
    headerLogoPath: "/257-logo.svg",
    headerLogoURL: "https://25-7.ru/",
    backGroundImage: "/auth-bg.webp",
    rentAreaURL: "https://25-7.pro/",
    rentAreaLabel: "Управляющая компания 25/7",
  },
};

export const config: Config = {
  apiUrl: getApiUrl(),
  template,
  ...templateConfigByTemplate[template],
};
